import { getDomainEndpoints } from '.';
 
import URLS from './urls';
const baseEndpoint = getDomainEndpoints();

const EndpointSources = {
    remote: () => ({
        buttonWidget: `${getBaseURL()}${URLS.WIDGET_BUTTON}`,
        location: `${getBaseURL()}${URLS.LOCATION}`,
        translation: `${getBaseURL()}${URLS.TRANSLATION}`,
        staticTranslation: `${getBaseURL()}${URLS.STATIC_TRANSLATION}`,
        optin: `${getBaseURL()}${URLS.OPTIN}`,
        calendars: `${getBaseURL()}${URLS.CALENDARS}`,
        calendar: `${getBaseURL()}${URLS.CALENDAR}`,

        oauthSession: `${getBaseURL()}${URLS.OAUTH_SESSION}`,
        subscriberActive: `${getBaseURL()}${URLS.SUBSCRIBER_ACTIVE}`,
        subscriber: `${getBaseURL()}${URLS.POST_SUBSCRIBER}`,
        completeSubscription: `${getBaseURL()}${URLS.COMPLETE_SUBSCRPITION}`,
        subscriberStatus: `${getBaseURL()}${URLS.SUBSCRIBER_STATUS}`,
        data: `${getBaseURL()}${URLS.DATA}`,
    }),

    local: () => ({
        buttonWidget: `${baseEndpoint.local}${URLS.WIDGET_BUTTON}`,
        location: `${baseEndpoint.local}${URLS.LOCATION}`,
        translation: `${baseEndpoint.local}${URLS.TRANSLATION}`,
        staticTranslation: `${baseEndpoint.local}${URLS.STATIC_TRANSLATION}`,
        optin: `${baseEndpoint.local}${URLS.OPTIN}`,
        calendars: `${baseEndpoint.local}${URLS.CALENDARS}`,
        calendar: `${baseEndpoint.local}${URLS.CALENDAR}`,

        oauthSession: `${baseEndpoint.local}${URLS.OAUTH_SESSION}`,
        subscriberActive: `${baseEndpoint.local}${URLS.SUBSCRIBER_ACTIVE}`,
        subscriber: `${baseEndpoint.local}${URLS.POST_SUBSCRIBER}`,
        completeSubscription: `${baseEndpoint.local}${URLS.COMPLETE_SUBSCRPITION}`,
        subscriberStatus: `${baseEndpoint.local}${URLS.SUBSCRIBER_STATUS}`,
        data: `${baseEndpoint.local}${URLS.DATA}`,
    }),

};

export function getBaseURL() {
    if (baseEndpoint[window.env]) {
        return baseEndpoint[window.env];
    }
    return baseEndpoint.test;
}

export function endpoints() {
    // baseEndpoint = getDomainEndpoints() ... / make endpoint dynamic in the future..
    if (window.env !== undefined && window.env !== 'local') {
        return EndpointSources.remote();
    }
    return EndpointSources.local();
}


